import React from 'react';
import StatusPage from './StatusPage';

export default function EndpointPage({ socket }) {
  return <StatusPage socket={socket} />;
}
